export const Success = () => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_15000_7054)">
      <path
        d="M31.9999 58.6666C17.2719 58.6666 5.33325 46.728 5.33325 32C5.33325 17.272 17.2719 5.33331 31.9999 5.33331C46.7279 5.33331 58.6666 17.272 58.6666 32C58.6666 46.728 46.7279 58.6666 31.9999 58.6666ZM29.3413 42.6666L48.1946 23.8106L44.4239 20.04L29.3413 35.1253L21.7973 27.5813L18.0266 31.352L29.3413 42.6666Z"
        fill="#4CBA78"
      />
    </g>
    <defs>
      <clipPath id="clip0_15000_7054">
        <rect width="64" height="64" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
